<!-- @format -->
@let reviewCount = reviewCount$ | async;

@if (reviewCount > 0) {
	@let selected = selected$ | async;
	@let pros = pros$ | async;
	@if (pros?.length > 0) {
		<div
			[ngClass]="{ 'hmf-mt-m hmf-pl-s hmf-pr-l-s': !isDrawer(), 'hmf-mt-l': isDrawer() }">
			<div class="tag-container" [ngClass]="{'hmf-mb-l': isDrawer() && i < pros.length - 1, 'hmf-mt-m': !isDrawer() }">
				<p class="tag-title hmf-text-transform-capitalize hmf-body-bold-l">Pros</p>

				<div class="chip-container horizontal-scroll hmf-mt-xs hmf-display-l-flex hmf-flex-l-wrap">
					@for (pro of pros; track $index;) {
						<product-reviews-chips
							class="chip-item-container hmf-mr-l-0 hmf-mr-xs"
							[ngClass]="{'hmf-mr-xxs': isDrawer(), 'hmf-mr-xs': !isDrawer()}"
							[label]="pro | featureLabel | titlecase"
							[isSelected]="isDrawer() && selected?.feature === pro?.feature"
							(chipClicked)="selectProFeature(pro?.feature, selected)">
						</product-reviews-chips>
					}
				</div>
        	</div>
    	</div>
	}

	@let cons = cons$ | async;
	@if (cons?.length > 0) {
		<div
			[ngClass]="{ 'hmf-mt-m hmf-pl-s hmf-pr-l-s': !isDrawer(), 'hmf-mt-l': isDrawer() }">
			<div class="tag-container" [ngClass]="{'hmf-mb-l': isDrawer() && i < cons.length - 1, 'hmf-mt-m': !isDrawer() }">
				<p class="tag-title hmf-text-transform-capitalize hmf-body-bold-l">Cons</p>

				<div class="chip-container horizontal-scroll hmf-mt-xs hmf-display-l-flex hmf-flex-l-wrap">
					@for (con of cons; track $index;) {
						<product-reviews-chips
							class="chip-item-container hmf-mr-l-0 hmf-mr-xs"
							[ngClass]="{'hmf-mr-xxs': isDrawer(), 'hmf-mr-xs': !isDrawer()}"
							[label]="con | featureLabel | titlecase"
							[isSelected]="isDrawer() && selected?.feature === con?.feature"
							(chipClicked)="selectConFeature(con?.feature, selected)">
						</product-reviews-chips>
					}
				</div>
        	</div>
    	</div>
	}
}
